export const adminJwtHeader = (): Record<string, string> => {
  let jwt: string | undefined = undefined;
  if (sessionStorage.getItem("PJ_AdminJwt")) {
    jwt = sessionStorage.getItem("PJ_AdminJwt") as string;
  }
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${jwt}`,
  };
};

export const formDataHeader = (): Record<string, string> => {
  return {
    "Content-Type": "multipart/form-data",
  };
};
